import { Outlet } from 'react-router-dom';
import Layout from '../Components/Layout';

export function CandidatePortal() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
